import { render, staticRenderFns } from "./IntegralRecord.vue?vue&type=template&id=62ed6ca5&scoped=true&"
import script from "./IntegralRecord.vue?vue&type=script&lang=js&"
export * from "./IntegralRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ed6ca5",
  null
  
)

export default component.exports